(() => {
  const initHome = (root = document) => {
    const reveals = root.querySelectorAll('.kt-home-reveal');
    if (!reveals.length || typeof IntersectionObserver === 'undefined') return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.16 });

    reveals.forEach((item) => observer.observe(item));
  };

  document.addEventListener('DOMContentLoaded', () => initHome(document));
  document.addEventListener('shopify:section:load', (event) => initHome(event.target));
})();
